import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, DCService } from "../../../services/index";
declare var google;

@Component({
  selector: "SampleReturn",
  templateUrl: "sampleReturn.html"
})
export class SampleReturn implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  data: any;
  remainList: any;
  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  printData;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    section: "",
    ret_no: "",
    ret_date: "",
    type: "",
    finyear: "2020-2021",
    design_no: "",
    wo_no: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "ret_no",
    orderDir: "desc"
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("printTemplate") printTemplate: TemplateRef<any>;

  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  dcdata: any = [];
  dcdata1: any;

  typeList = ["Swatch", "Sample"];
  constructor(
    public store: Store<fromRootStore.State>,
    public dcservice: DCService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    this.data = {
      dcdata: [],
      dcdata1: []
    };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center"
      },
      {
        name: "Ret No",
        prop: "ret_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80
      },
      {
        name: "Ret Date",
        prop: "fdate",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "Section",
        prop: "section",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "Type",
        prop: "type",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "Action",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        sortable: false,
        cellTemplate: this.editDeleteTemplate
      }
     
    ];
    this.toggleCol = Object.assign({}, this.columns);
    this.finyearCombo();
    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function() {
      $("#section").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getSampleReturnList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.section = "";
    this.filter.type = "";
    this.filter.ret_date = "";
    this.filter.ret_no = "";
    this.filter.wo_no = "";
    this.filter.design_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getSampleReturnList();
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
    });
  }
  getSampleReturnList(): void {
    if (this.filter.ret_date == "") {
      this.filter.ret_date == "";
    } else {
      this.filter.ret_date = this.datePipe.transform(
        this.filter.ret_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      section: this.filter.section,
      type: this.filter.type,
      ret_no: this.filter.ret_no,
      ret_date: this.filter.ret_date,
      finyear: this.filter.finyear,
      wo_no: this.filter.wo_no,
      design_no: this.filter.design_no
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.dcservice
      .getsampleReturnDc(params)
      .then(function(res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.dcdata = res.data;
      });
  }

  addEditSampleReturn(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getSampleReturnList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          tabName: "ADD SAMPLE RETURN",
          title: "ADD SAMPLE RETURN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditSampRet"
        }
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT SAMPLE RETURN",
          title: "EDIT SAMPLE RETURN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditSampRet"
        }
      };
    } else {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW SAMPLE RETURN",
          title: "VIEW SAMPLE RETURN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditSampRet"
        }
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }

  clickPrintavail(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);

    that.isLoadMask = that.dcservice
      .dcavailPrint(params)
      .then(function(res: any) {});
  }

  deleteDC(row: any): void {
    row.tabevent = undefined;
    let that = this;
    swal({
      title: "Are you sure to delete this Return Details?",
      text:
        "You will not be able to recover this Return" + " " + row["ret_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(
      function() {
        that.isLoadMask = that.dcservice.sampleReturndelete(row).then(function(res: any) {
          that.loadingIndicator = false;
          that.getSampleReturnList();
          let errtype = "success",
            errmsg = res.message;
          if (!res.success) {
            errtype = "error";
          }

          that.toasterService.pop({
            bodyOutputType: 1,
            type: errtype,
            title: errtype.toUpperCase(),
            body: errmsg
          });
        });
      },
      function(dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/sampleReturn.ts